import { useState } from 'react'

export function useSelectable<T>(values: T[], max: number = Infinity) {
  const [arr, setArr] = useState<T[]>(values)
  const toggle = (v: T) => {
    setArr((prev) => {
      const next = prev.filter((itm) => itm !== v)
      if (next.length == prev.length && next.length < max) next.push(v)
      return next
      // return max ? next.slice(Math.max(next.length - max, 0), next.length + 1) : next
    })
  }
  return [arr, toggle, setArr] as const
}
